import { FC } from 'react'

import { Grid, GridItem, Skeleton, Stack, Table } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

const RequiredActionsHeaderSkeleton: FC = () => {
  return (
    <Grid col={12}>
      <GridItem span={6}>
        <Grid col={12} gap={16}>
          <GridItem span={6}>
            <Skeleton variant="button" fullWidth />
          </GridItem>
          <GridItem span={3}>
            <Skeleton variant="button" fullWidth />
          </GridItem>
        </Grid>
      </GridItem>
      <GridItem span={4} />
      <GridItem span={2}>
        <Grid col={12}>
          <GridItem span={12}>
            <Skeleton variant="button" fullWidth />
          </GridItem>
        </Grid>
      </GridItem>
    </Grid>
  )
}

export const RequiredActionsListSkeleton: FC = () => {
  const { translate } = useLocalisation()
  const columns = [
    {
      id: 'description',
      header: translate('required-actions.table.description'),
      cell: () => <Skeleton />,
    },
    {
      id: 'id',

      header: translate('required-actions.table.id'),
      cell: () => <Skeleton />,
    },
    {
      id: 'dueDate',
      header: translate('required-actions.table.dueDate'),
      cell: () => <Skeleton />,
    },
    {
      id: 'status',
      header: translate('required-actions.table.status'),
      cell: () => <Skeleton />,
    },
    {
      id: 'actions',
      header: '',
      cell: () => <Skeleton />,
    },
  ]
  return <Table columns={columns} data={[1, 2, 3]} footless />
}

export const RequiredActionsMainSkeleton: FC = () => {
  return (
    <Stack gap={24}>
      <RequiredActionsHeaderSkeleton />
      <RequiredActionsListSkeleton />
    </Stack>
  )
}
